import { atsApiQuery } from '..';

export const scheduleReportsEmailApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getAllScheduleReports: builder.query({
        providesTags: ['GetAllScheduleReports'],
        transformResponse: (response) => response?.data,
        query: ({ params }) => {
          return {
            method: 'get',
            url: `reports/actions/recurring_emails`,
            params,
          };
        },
      }),

      getScheduleReportById: builder.query({
        providesTags: ['GetScheduleReportById'],
        transformResponse: (response) => response?.data,
        query: ({ id }) => {
          return {
            method: 'get',
            url: `reports/actions/recurring_emails/${id}`,
          };
        },
      }),

      createScheduleReport: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ id, payload }) => {
          return {
            method: 'post',
            url: `reports/actions/recurring_emails`,
            data: payload,
          };
        },
        invalidatesTags: (result) => {
          if (result) {
            return [{ type: 'GetAllScheduleReports' }];
          }
          return [];
        },
      }),

      updateScheduleReport: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ id, payload }) => {
          return {
            method: 'put',
            url: `reports/actions/recurring_emails/${id}`,
            data: payload,
          };
        },
        invalidatesTags: (result) => {
          if (result) {
            return [{ type: 'GetAllScheduleReports' }];
          }
          return [];
        },
      }),

      deleteScheduleReport: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ id }) => {
          return {
            method: 'delete',
            url: `reports/actions/recurring_emails/${id}`,
          };
        },
        invalidatesTags: (result) => {
          if (result) {
            return [{ type: 'GetAllScheduleReports' }];
          }
          return [];
        },
      }),

      downloadReport: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload }) => {
          return {
            method: 'post',
            url: `reports/saved_reports/generate`,
            data: payload,
          };
        },
      }),

      pollDownloadReports: builder.query({
        transformResponse: (response) => response?.data,
        query: ({ payload, id }) => {
          return {
            method: 'get',
            url: `reports/saved_reports/${id}`,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useLazyGetAllScheduleReportsQuery,
  useLazyGetScheduleReportByIdQuery,
  useCreateScheduleReportMutation,
  useUpdateScheduleReportMutation,
  useDeleteScheduleReportMutation,
  useDownloadReportMutation,
  useLazyPollDownloadReportsQuery,
} = scheduleReportsEmailApi;
